"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
// Helper React Component for useRoutes hook
function UseRoutes(_ref) {
  var routes = _ref.routes;
  return (0, _reactRouterDom.useRoutes)(routes);
}
var _default = exports.default = UseRoutes;